import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { routeAnimations } from '../../../animations';

@Component({
  selector: 'app-settings-overview',
  templateUrl: 'settings-overview.component.html',
  animations: [routeAnimations],
  standalone: false,
})
export class SettingsOverviewComponent {
  getState = (outlet: RouterOutlet) => outlet.isActivated && outlet.activatedRoute.routeConfig.data;
}
